const mutations = {
    setDisplayCoverClose(state, { isDisplayed }) {
        state.isDisplayed = isDisplayed
    }
}

export default mutations
